import React, { FC } from 'react'
import { Tooltip } from '@wmgtech/legato'
import styles from './search-item.module.scss'
import { SearchItemProps } from './SearchItem.props'

export const SearchItem: FC<SearchItemProps> = ({ title, subtitle }) => {
  return (
    <Tooltip title={title} message={subtitle} colorType="info" className={styles.tooltip} >
      <div className={styles.wrapper}>
        <dl className={styles.container}>
          <dt>{title}</dt>
          <dd>{subtitle}</dd>
        </dl>
      </div>
    </Tooltip>
  )
}
